"use strict";

function __export(m) {
  for (var p in m) {
    if (!exports.hasOwnProperty(p)) exports[p] = m[p];
  }
}

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var reducer_1 = __importDefault(require("./reducer"));

exports.createAppReducer = reducer_1.default;

var admin_1 = __importDefault(require("./reducer/admin"));

exports.adminReducer = admin_1.default;

var i18n_1 = __importDefault(require("./reducer/i18n"));

exports.i18nReducer = i18n_1.default;

var queryReducer_1 = __importDefault(require("./reducer/admin/resource/list/queryReducer"));

exports.queryReducer = queryReducer_1.default;

var CoreAdmin_1 = __importDefault(require("./CoreAdmin"));

exports.CoreAdmin = CoreAdmin_1.default;

var CoreAdminRouter_1 = __importDefault(require("./CoreAdminRouter"));

exports.CoreAdminRouter = CoreAdminRouter_1.default;

var createAdminStore_1 = __importDefault(require("./createAdminStore"));

exports.createAdminStore = createAdminStore_1.default;

var RoutesWithLayout_1 = __importDefault(require("./RoutesWithLayout"));

exports.RoutesWithLayout = RoutesWithLayout_1.default;

var Resource_1 = __importDefault(require("./Resource"));

exports.Resource = Resource_1.default;

__export(require("./dataFetchActions"));

__export(require("./actions"));

__export(require("./auth"));

__export(require("./i18n"));

__export(require("./inference"));

__export(require("./util"));

__export(require("./controller"));

__export(require("./form"));

var reducer_2 = require("./reducer");

exports.getResources = reducer_2.getResources;
exports.getReferenceResource = reducer_2.getReferenceResource;
exports.getLocale = reducer_2.getLocale;
exports.getNotification = reducer_2.getNotification;
exports.getPossibleReferences = reducer_2.getPossibleReferences;
exports.getPossibleReferenceValues = reducer_2.getPossibleReferenceValues;

var oneToMany_1 = require("./reducer/admin/references/oneToMany");

exports.getIds = oneToMany_1.getIds;
exports.getReferences = oneToMany_1.getReferences;
exports.getReferencesByIds = oneToMany_1.getReferencesByIds;
exports.nameRelatedTo = oneToMany_1.nameRelatedTo;

__export(require("./sideEffect"));